import { api } from 'utils';

const SERVICE_ROUTE = 'postalcodes';

const fetchRatingByPlaceId = async (placeId: string) => {
  if (placeId) {
    try {
      const { data } = await api.get(`/${SERVICE_ROUTE}/rating?placeId=${placeId}&country=de`);
      return data;
    } catch (e) {
      return { rate: 3, reviewCount: 0 };
    }
  }
};

export default {
  fetchRatingByPlaceId,
};
